import React from 'react';
import { Plus, Search, Folder } from 'lucide-react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionTestId?: string;
  variant?: 'default' | 'search' | 'folder';
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  actionTestId,
  variant = 'default',
}) => {
  const getDefaultIcon = () => {
    switch (variant) {
      case 'search':
        return <Search size={48} className="text-gray-400" />;
      case 'folder':
        return <Folder size={48} className="text-gray-400" />;
      default:
        return null;
    }
  };

  const displayIcon = icon || getDefaultIcon();

  return (
    <div
      data-testid="empty-state"
      className="flex flex-col items-center justify-center py-16 px-8 text-center"
    >
      {displayIcon && (
        <div className="mb-4 p-4 rounded-full bg-primary/5">
          {displayIcon}
        </div>
      )}
      <h3 className="text-base font-semibold text-text-primary mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-text-secondary mb-6 max-w-sm">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          data-testid={actionTestId}
          className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-white text-sm font-medium rounded-md hover:bg-primary-dark transition-colors"
        >
          <Plus size={18} />
          {actionLabel}
        </button>
      )}
    </div>
  );
};
